<!-- eslint-disable camelcase -->
<script setup lang="ts">
import {
    PersonData,
    MultiplesclerosisCondition,
    MedicalCondition,
    PrescribedConditionTypes,
} from "@/entities/conditions";
import MedicalFormBuilder from "@/components/medicalConditionForms/MedicalFormBuilder.vue";
import { parseSchema } from "@/components/medicalConditionForms/schema";
import { useMedicalForm } from "../useMedicalForm";

import multiplesclerosis from "./multiplesclerosis.json";

export interface Props {
    condition: MultiplesclerosisCondition,
    personDetails: PersonData
}

const props = defineProps<Props>();

const emit = defineEmits<{
        (on:"update:condition", value: MedicalCondition): void
    }>();

const { onConditionUpdate, state } = useMedicalForm<
    {type: PrescribedConditionTypes.Multiplesclerosis} & MultiplesclerosisCondition
>({
    ...props.condition,
    type: PrescribedConditionTypes.Multiplesclerosis,
    medications: props.condition.medications || [],
    multiplesclerosis_date: props.condition.multiplesclerosis_date || "",
}, emit);
</script>

<template>
    <MedicalFormBuilder
        :diagnosis-date="state.condition.multiplesclerosis_date"
        :schema="parseSchema(multiplesclerosis)"
        :initial-form="state.condition"
        :person-details="props.personDetails"
        @update:form="onConditionUpdate"
    />
</template>
